<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">青海高端有机服务平台</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
        <el-form-item prop="username">
          <el-input v-model="ruleForm.username" placeholder="用户名">
            <el-button slot="prepend" icon="el-icon-user"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="密码"
            v-model="ruleForm.password"
            @keyup.enter.native="submitForm('ruleForm')"
          >
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
          </el-input>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" :loading="btnLoading" @click="submitForm('ruleForm')">登录</el-button>
        </div>
        <p class="login-tips">Tips : 填写用户名和密码。</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/api.js";
import axios from 'axios'
import storage from "@/utils/storage";
import md5 from "js-md5";
export default {
  data: function() {
    return {
      ruleForm: {
        username: "",
        password: ""
      },
      btnLoading: false,
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          
          if (/*localStorage.getItem("token") == null*/true) { //强制登录，防止else出现异常。
            var loginParams = {
              userName: this.ruleForm.username,
              passWord: this.ruleForm.password
            };
            
            login(loginParams)
              .then(data => {
                if (data != null) {
                  let user = {
                    UserName: data.UserName,
                    OrgName: data.OrgName,
                    RegionCode:[],
                    LoginDate:data.LoginDate,
                    LoginAddress:data.LoginAddress,
                    RoleName: data.RoleName
                  };
                  if(data.RegionCode!=undefined)
                  {
                    var region=data.RegionCode;
                    if(data.RegionCode.length==6)
                    {
                      region=region+"000000"
                    }
                    else if(data.RegionCode.length==9)
                    {
                      region=region+"000"
                    }
                    console.log(region);
                    if(region.substr(2)!="0000000000")
                    {
                      if(region.substr(4,8)=="00000000")
                      {
                        //市级
                        user.RegionCode[0]=region;
                      }
                      else if(region.substr(6,6)=="000000")
                      {
                        //县级
                        user.RegionCode[0]=region.substr(0,4)+"00000000";
                        user.RegionCode[1]=region;
                      }
                      else
                      {
                        //乡镇
                        user.RegionCode[0]=region.substr(0,4)+"00000000";
                        user.RegionCode[1]=region.substr(0,6)+"000000";
                        user.RegionCode[2]=region;
                      }
                    }
                  }
                  storage.localSet("user", user);
                  storage.localSet("loginTime", new Date().getTime());
                  this.$router.push("/");
                }
              })
              .catch(err => {
                this.btnLoading = false;
              });
          } else {
            this.$router.push("/");
          }
        } else {
          console.log("error submit!!");
        }
      });
    }
  }
};
</script>

<style scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/login-bg.jpg);
  background-size: 100%;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Login.vue